import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./SettingsListItem.module.css";

import EmeraldIconGreen from "./Icons/EmeraldIcon.svg";
import EmeraldIcon from "./Icons/EmeraldIcon1.svg";
import Toggler from "../Toggler";

export const SettingsListItem = ({ green, name }) => {
  const [toggled, setToggled] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.nameContainer}>
        {green && <img src={EmeraldIconGreen} />}
        {!green && <img src={EmeraldIcon} />}
        <div className={styles.name}>{name}</div>
      </div>
      <div>
        <Toggler
          onChange={() => setToggled(!toggled)}
          toggled={toggled}
          color={"#39B54A"}
        />
      </div>
    </div>
  );
};

SettingsListItem.propTypes = {};
